import jsfix from "jsfix";
import $ from "jquery";

// Read a cookie
function getCookie(name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(";").shift();
  return null;
}

// Set a cookie
function setCookie(name, value, days = 7) {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
}

// Delete a cookie
function deleteCookie(name) {
  document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;`;
}

function is_public_area() {
  const path = window.location.pathname;
  if (path.startsWith("/en/")) {
    return true;
  }
  if (path.startsWith("/es/")) {
    return true;
  }
  if (path.startsWith("/fr/")) {
    return true;
  }
  if (path.startsWith("/pl/")) {
    return true;
  }
  if (path.startsWith("/cz/")) {
    return true;
  }

  // better just know which are public areas
  return false;
  // if (path.startsWith("/file/")) {
  //   return false;
  // }
  // if (path.startsWith("/form/")) {
  //   return false;
  // }
  // if (path.startsWith("/users/")) {
  //   return false;
  // }
  // if (path.startsWith("/report/")) {
  //   return false;
  // }
  // if (path.startsWith("/join/")) {
  //   return false;
  // }
  // if ($(".home").length > 0) {
  //   return false;
  // }

  // return true;
}

function cookielaw() {
  if (!is_public_area()) return;

  const $cookielawBanner = $("#CookielawBanner");
  const gdpr_cookies = getCookie("gdpr_cookies");
  if (gdpr_cookies) {
    $cookielawBanner.hide();
  } else {
    $cookielawBanner.show();
  }

  if (gdpr_cookies === "all") {
    enable_analytics();
  }

  jsfix.register("js-click-accept-cookie", function ($el, sel) {
    $el.click(function () {
      setCookie("gdpr_cookies", sel, 365);
      $cookielawBanner.slideUp();
      if (sel === "all") {
        enable_analytics();
      }
    });
  });
}

function addScript(url) {
  const script = document.createElement("script");
  script.src = url;
  document.head.appendChild(script);
}

function enable_analytics() {
  addScript("https://www.googletagmanager.com/gtag/js?id=G-BTKBYQQ3XF");

  window.dataLayer = window.dataLayer || [];
  function gtag() {
    dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", "G-BTKBYQQ3XF");
}

cookielaw();

export default cookielaw;
